import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Banner } from "../Banner";
import { useState } from "react";
import "./Layout.css";

function Layout()
{
  const [categories, setCategories] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  React.useEffect(() => {
    fetch("/config/categories.json")
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error cargando categorías", error));
  }, []);

  return (
      <div className="layout">       
        <Banner />      
        
        <nav className="navbar">
          <ul>
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/All">Todos los Productos</Link></li>

            {/* Categorías con submenús */}
            <li className="menu-item" onClick={toggleMenu}>
              <Link>Categorías</Link>
              
              {(!isMobile || menuOpen) && (
                <ul className="submenu">
                  {categories.map((category) => (
                    <li key={category.id} className="submenu-item">
                      <Link to={`/category/${category.id}`} className="submenu-link">{category.name}</Link>
                      {category.subcategories && (
                        <ul className="sub-submenu">
                          {category.subcategories.map((sub) => (
                            <li key={sub.id} onClick={closeMenu}>
                              <Link to={`/category/${category.id}/${sub.id}`} className="submenu-link">
                                {sub.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}

            </li>          
            
            <li><Link to="/howbuy">Cómo Comprar</Link></li>
          </ul>
        </nav>
  
        {/* Contenido dinámico de la página */}
        <main className="content">
          <Outlet />
        </main>
      </div>
    );

};

export { Layout };

